import React from "react";

const InputWithIcon = ({
  leftIcon,
  rightIcon,
  value,
  onChange,
  placeholder = "",
  className = "",
  leftIconClassName = "",
  rightIconClassName = "",
  inputClassName = "",
  onClickIcon,
  disabled,
  ...props
}) => {
  return (
    <div
      className={`${
        disabled ? "bg-[#C7C7C7] text-gray-400" : "bg-[#F2F4F8]"
      } rounded-xl overflow-hidden flex items-stretch shadow-[0px_1.5px_1px_#C1C7CD] ${className}`}
    >
      {/* Left Icon (optional) */}
      {leftIcon && (
        <div
          onClick={onClickIcon}
          className={`px-5 pr-1 flex justify-center items-center font-bold ${leftIconClassName}`}
        >
          {leftIcon}
        </div>
      )}

      <input
        type="text"
        className={`bg-transparent p-[12px] outline-none border-none flex-1 ${inputClassName}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />

      {/* Right Icon (optional) */}
      {rightIcon && (
        <div
          className={`px-5 font-bold bg-white text-sm w-full max-w-[60px] flex justify-center items-center ${rightIconClassName}`}
          onClick={onClickIcon}
        >
          {rightIcon}
        </div>
      )}
    </div>
  );
};

export default InputWithIcon;
